export interface GridColumnHeader {
  selectedValues: any[];
  filterOptions: { label: string; value: string }[];
  field: string;
  order: number;
  title: string;
  type: string;
  width: string;
  required: boolean;
  disabled?: boolean;
  advancefilter: AdvanceFilterModel;
}

export interface AdvanceFilterModel {
  isAdvanceFilterUsed: boolean;
  operator: 'and' | 'or';
  matchModeOptions: MatchModeOptionsModel[];
  constraints: ConstraintsModel[];
}

export interface ConstraintsModel {
  value: string;
  matchMode: string;
}

export interface MatchModeOptionsModel {
  value: string;
  label: string;
}

export const dateMatchModes: MatchModeOptionsModel[] = [
  { label: 'Is after or equal to', value: 'gte' },
  { label: 'Is after', value: 'gt' },
  { label: 'Is before or equal to', value: 'lte' },
  { label: 'Is before', value: 'lt' },
  { label: 'Is null', value: 'isnull' },
  { label: 'Is not null', value: 'isnotnull' },
];

export const textNumberMatchModes: MatchModeOptionsModel[] = [
  { label: 'Is equal to', value: 'eq' },
  { label: 'Starts With', value: 'startswith' },
  { label: 'Contains', value: 'contains' },
  { label: 'Does not contain', value: 'doesnotcontain' },
  { label: 'Ends with', value: 'endswith' },
];

export const dateConstraints: ConstraintsModel[] = [
  { value: '', matchMode: 'gte' },
  { value: '', matchMode: 'gte' },
];

export const textNumberConstraints: ConstraintsModel[] = [
  { value: '', matchMode: 'eq' },
  { value: '', matchMode: 'eq' },
];